
var sft =localStorage.getItem('sft');
var isEmailVerified =  getCookie("isEmailVerified");
var showResendPopUpOnLoad= getCookie("showResendPopUpOnLoad");
var showexpiredTrialPopUp= getCookie("showexpiredTrialPopUp");
var show_creating_account_failure_pop_up= getCookie("show_creating_account_failure_pop_up");
var emailVerifyCookie = sessionStorage.getItem('emailVerified');
var params = new URLSearchParams(window.location.search);
var isMailResend = params.get('resend');
var isMailResendAgain = params.get('resendAgain');
var isActivationFailure = params.get('is_not_active')


let agencyData = getCookie('agency_user_data');
agencyData = agencyData && agencyData != '' ? JSON.parse(agencyData) : null;
const isOneTapJourney = localStorage.getItem('one-tap-journey');


if (window.location.href.includes('agencyData') && agencyData) {
    window.history.replaceState({}, document.title, "/");
    startFreeTrial();
}

if (getCookie('is_agency_journey') != '' && agencyData) {
    document.getElementById("loader_pop-up").style.display = "flex";
            document.body.style.overflow = "hidden";
    deleteCookie("is_agency_journey");
    startFreeTrial();
}

if(sft == "true" && !isMailResend && !isMailResendAgain){
   if (userLoggedIn) {
       let isSameEmailUsed = checkIsSameAgencyEmail();
       let continueAgencyFlow = getCookie('continue_agency_journey');
       continueAgencyFlow = continueAgencyFlow == 'true' ? true : false;
       if ( !agencyData || ( agencyData && isSameEmailUsed) || continueAgencyFlow) {
           if (!is_email_verified && emailVerifyCookie != "true") {
               checkIfEmailVerified(true, isEmailVerified);
           } else {
               ifEmailVerified();
           }
       }
       else if (agencyData && !isSameEmailUsed) {
        document.getElementById('agency_different_email_login_pop-up').style.display = 'flex';
       }
   }
}

// Show Expired access popup when subscription expires
if(currentCompanyData && currentCompanyData.subDaysLeft < 0){
    ifEmailVerified();
}

if(customerID && isOneTapJourney && !trialCompanyInfo){
    // once funneled , journey is complete as of now for us , so removing the local storage item
    localStorage.removeItem('one-tap-journey')
    startFreeTrial();
}

function checkIsSameAgencyEmail() {
    if (agencyData && agencyData.email && agencyData.email != '') {
        if( customerEmail != agencyData.email ) {
            return false;
        } else {
            return true;
        }
    }
    else {
        return true;
    }
}

function continueAgencyJourney() {
    document.getElementById(
        "agency_different_email_login_pop-up"
    ).style.display = "none";

    createCookie('continue_agency_journey', true);

    if (activeUsersArray.length > 0 && !currentCompany) {
        localStorage.setItem("sft", true);
        window.location.href = switchCompanyURL;
    } else {
        if (!is_email_verified && emailVerifyCookie != "true") {
            checkIfEmailVerified(true, "false");
        } else {
            ifEmailVerified();
        }
    }
}

function handleAgencyLogout() {
    createCookie('is_agency_journey', true);
    window.location.href = logout_url;
}

function startFreeTrial(){
    if (userLoggedIn){
        let isSameEmailUsed = checkIsSameAgencyEmail();
        document.getElementById('loader_pop-up').style.display = 'none';
        if ( !agencyData || ( agencyData && isSameEmailUsed) ) {
            if(!is_email_verified && emailVerifyCookie !="true"){
                document.cookie="showResendPopUpOnLoad=true";
                checkIfEmailVerified(false);
            }
            else{
                localStorage.setItem('sft',false);
                window.location.href = additionalInfoURL;
            }   
        }
        else if (agencyData && !isSameEmailUsed) {
            document.getElementById('agency_different_email_login_pop-up').style.display = 'flex';
        }
    }
    else{
        localStorage.setItem('sft',true);
        document.cookie="isEmailVerified=false";
        document.cookie="showResendPopUpOnLoad=true";
        if (agencyData && agencyData.email && agencyData.email != ''){
            window.location.href = sft_auth0_login_url_with_prefilled_email.replace('[emailId]', agencyData.email);
        } else {
            window.location.href = sft_auth0_login_url;
        }
    }
}
if(isMailResend){
    document.getElementById("resend_email_pop-up").style.display = "flex";
    $('.mfbusiness-submit-button').focus();
}
if(isMailResendAgain){
    document.getElementById("resend_email_again_pop-up").style.display = "flex";
    $('.mfbusiness-submit-button').focus();
}
if(isActivationFailure=='true'){
    if(show_creating_account_failure_pop_up == ""){
        document.getElementById("creating_account_pop-up").style.display = "flex";
        $('.mfbusiness-submit-button').focus();
    }
}
function resendEmail(){
    document.getElementById('resendEmail').style.display = "none";
    document.getElementById('resendLoader').style.display = "block";
    document.cookie="showResendPopUpOnLoad=false";
    window.location.href = sft_auth0_resend_verification_url ;
}
function resendMailPopUp(){
    document.getElementById("resendMailLink").style.display = "none";
    document.getElementById("resendAgainLoader").style.display = "inline-block";
    window.location.href = sft_auth0_resend_verification_again_url;
}
function checkIfEmailVerified(sftFlag,isEmailVerified){
    if(is_email_verified || emailVerifyCookie == "true"){
        ifEmailVerified();
    }
    else{ 
        if (agencyData && !sft) {
            localStorage.setItem('sft', true);
        }
        
        if(sftFlag && isEmailVerified=="false"){
            $('#shopify-section-mfbusiness').css('display','none');
            $("#loader_pop-up").css('display','flex');
            $("body").css('overflow','hidden');
            document.cookie="isEmailVerified=true";
            document.getElementById("shopify-section-mfbusiness").style.display = "none";
            document.getElementById("loader_pop-up").style.display = "flex";
            document.body.style.overflow = "hidden";
            if(Shopify.locale === 'pt-BR'){
                window.location.href = "/pt/pages/verify-email";
            } else {
                window.location.href = "/pages/verify-email";
            }
        }
        else{
            showResendPopUpOnLoad = getCookie("showResendPopUpOnLoad");
            if(showResendPopUpOnLoad == "true" && emailVerifyCookie != "true"){
                document.getElementById("email_verified_false_pop-up").style.display = "flex";
                $('#resendEmail').focus();
            }
        }
    }
}
function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
} 
$('.pop-up-close').on('click', function () {
    if(isMailResend)
        window.history.pushState({}, document.title, "/" );
    if(isMailResendAgain)
        window.history.pushState({}, document.title, "/" );
});
$('#email_verified_false_pop-up .pop-up-close').on('click', function () {
    document.cookie="showResendPopUpOnLoad=false";
});
$('#creating_account_pop-up .pop-up-close').on('click', function () {
    document.cookie="show_creating_account_failure_pop_up=false";
});
function ifEmailVerified(){
    localStorage.setItem('sft',false);
    if(!is_trial_active ) {
        // if user has active trial || no trial info available || No Subscription Info Available or Active Subscription
        if((!is_trial_expired && !currentCompanyData.subEndDate) ||  (currentCompanyData.subDaysLeft && currentCompanyData.subDaysLeft>0)){
            document.getElementById("shopify-section-mfbusiness").style.display = "none";
            document.getElementById("loader_pop-up").style.display = "flex";
            document.body.style.overflow = "hidden";
            window.location.href = additionalInfoURL;
        }
        else{
            if (agencyData) {
                window.location.href = additionalInfoURL;
            }
            else {
                showexpiredTrialPopUp = getCookie("showexpiredTrialPopUp");
                if(showexpiredTrialPopUp == ""){
                    let url = new URL(location.href);
                    if(url.pathname !== "/cart"){
                        document.getElementById("expired_trial_pop-up").style.display = "flex";
                        document.cookie="showexpiredTrialPopUp=true";
                    }
                }
            }
        }   
    }
    else if (is_trial_active && agencyData) {
        window.location.href = additionalInfoURL;
    }
}
function trialExpired(){ 
    document.getElementById("expired_trial_pop-up").style.display = "none";
    document.cookie="showexpiredTrialPopUp=true";
}
function activationFailure(){ 
    document.getElementById("creating_account_pop-up").style.display = "none";
    document.cookie="show_creating_account_failure_pop_up=false";
}
function clearIndividualFlow(){
    localStorage.removeItem('isIndividual');
    localStorage.removeItem('isIndividualRedirect');
    localStorage.removeItem('cartFormData');
    sessionStorage.removeItem('newIndividualAccount');
    $.getJSON("/cart/clear", function(e) {location.reload()});
}